var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.887 11.0619H2.68652",
    stroke: "#9CA3AF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76074 4.60025H12.9612",
    stroke: "#9CA3AF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81785 4.56417C5.81785 3.7004 5.11241 3 4.24242 3C3.37243 3 2.66699 3.7004 2.66699 4.56417C2.66699 5.42794 3.37243 6.12834 4.24242 6.12834C5.11241 6.12834 5.81785 5.42794 5.81785 4.56417Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 11.0358C13.3335 10.1721 12.6286 9.47166 11.7586 9.47166C10.8881 9.47166 10.1826 10.1721 10.1826 11.0358C10.1826 11.8996 10.8881 12.6 11.7586 12.6C12.6286 12.6 13.3335 11.8996 13.3335 11.0358Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGrey);
export default __webpack_public_path__ + "static/media/Filter-grey.eaffec955bba08e355e257d1319936c7.svg";
export { ForwardRef as ReactComponent };